import gql from 'graphql-tag';

export const GET_SERVICE_SETTINGS_MODAL_STATE = gql`
  {
    serviceSettingsModal @client {
      isOpen
    }
  }
`;
